import React from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { Link } from 'react-router-dom';
import { assets, routeTo } from './products';

const voidTags = new Set(['img', 'input', 'br', 'hr', 'meta', 'link', 'source', 'wbr', 'area']);
const argument = value => /^['"]/.test(value) ? value.slice(1, -1) : /^\d+$/.test(value) ? Number(value) : value;

// Convert the approved, build-time-only templates to real React nodes. Event
// attributes are removed and mapped to an explicit whitelist: no eval or globals.
export const ReferenceMarkup = ({ html, prefix, tr, onAction, components = {}, overrides = {} }) => {
  let index = 0;
  const options = {
    replace(node) {
      if (node.type !== 'tag') return;
      const a = node.attribs || {};
      const key = index++;
      if (components[a.id]) return components[a.id]();
      if (a.class === 'calculator' && components.calculator) return components.calculator();
      const clean = Object.fromEntries(Object.entries(a).filter(([name]) => !name.startsWith('on')));
      const props = { ...attributesToProps(clean) };
      if ('fetchpriority' in props) { props.fetchPriority = props.fetchpriority; delete props.fetchpriority; }
      const raw = a.onclick || a.onchange || a.oninput;
      let action;
      if (raw) {
        const route = raw.match(/^location\.hash=['"]([^'"]+)['"]$/);
        const call = raw.match(/^(\w+)\((.*)\)$/);
        if (route) action = ['navigate', [route[1]]];
        else if (call) action = [call[1], call[2] ? call[2].split(',').map(x => argument(x.trim())) : []];
        if (action) {
          const eventName = a.oninput || a.onchange ? 'onChange' : 'onClick';
          props[eventName] = event => onAction?.(action[0], action[1], event);
        }
      }
      const identity = a.id || (a['data-compare'] ? `compare-${a['data-compare']}` : action ? action[0] : node.name);
      props['data-testid'] = `${prefix}-${identity}-${key}`;
      if (a.id) props['data-testid'] = `${prefix}-${a.id}`;
      if (a.class === 'lang') props['data-testid'] = 'language-toggle';
      if (a.class === 'menu') props['data-testid'] = 'mobile-menu-toggle';
      if (a['data-compare']) props['data-testid'] = `compare-${a['data-compare']}`;
      if (a.class === 'hotspot') props['data-testid'] = `product-hotspot-${action[1][0] + 1}`;
      if (node.name === 'button') props.type = 'button';
      if (node.name === 'input' && a.type === 'checkbox') {
        props.checked = a.checked !== undefined;
        delete props.defaultChecked;
      }
      const labels = {
        'Switch language': tr('English', 'मराठी'),
        'Open menu': tr('मेनू उघडा', 'Open menu'),
        'KisanDrone home': tr('KisanDrone होम', 'KisanDrone home'),
        'Tank details': tr('टाकीची माहिती', 'Tank details'),
        'Frame details': tr('फ्रेमची माहिती', 'Frame details'),
        'Folding arm details': tr('फोल्डिंग आर्म्सची माहिती', 'Folding arm details'),
        'Product details': tr('उत्पादनाची माहिती', 'Product details'),
        'View drone demonstration videos': tr('ड्रोन प्रात्यक्षिक व्हिडिओ पहा', 'View drone demonstration videos'),
      };
      if (labels[a['aria-label']]) props['aria-label'] = labels[a['aria-label']];
      if (a.src?.startsWith('assets/')) {
        props.src = assets[a.src.slice(7)];
        if (!props.src) return <div key={key} className="asset-unavailable" role="img" aria-label={tr('Flower Blower चे छायाचित्र उपलब्ध नाही', 'Flower Blower photograph unavailable')} data-testid={`${prefix}-flower-image-unavailable`}><span>Flower Blower</span><small>{tr('छायाचित्र लवकरच', 'Photograph coming soon')}</small></div>;
      }
      let children = domToReact(node.children || [], options);
      const override = overrides[a.id] || (a.class === 'hotspot' ? overrides.hotspot : null) || (a.class === 'menu' ? overrides.menu : null);
      if (override) {
        const changes = override(a, props);
        if (changes?.props) Object.assign(props, changes.props);
        if (changes && 'children' in changes) children = changes.children;
      }
      if (node.name === 'a' && a.href?.startsWith('#')) {
        props.to = routeTo(a.href.slice(1) || 'home');
        delete props.href;
        props.onClick = event => onAction?.('closeMenu', [], event);
        return <Link key={key} {...props}>{children}</Link>;
      }
      if (node.name === 'a' && ['/blog', '/privacy-policy'].includes(a.href)) {
        props.to = a.href; delete props.href;
        return <Link key={key} {...props}>{children}</Link>;
      }
      return voidTags.has(node.name) ? React.createElement(node.name, { ...props, key }) : React.createElement(node.name, { ...props, key }, children);
    },
  };
  return <>{parse(html, options)}</>;
};